import LoadingSpinner from "@/components/LoadingSpinner";
import { cn } from "@/lib/utils";

export const LoadingMoreSpinner = () => (
  <div
    className={cn(
      "absolute bottom-0 left-[calc(50%-40px)] right-0 top-0 z-20",
      "flex items-center justify-center rounded-full",
      "h-10 w-10",
      "bg-blue-500",
    )}
  >
    <LoadingSpinner size="6" className="mr-0 fill-blue-500" />
  </div>
);
